// extracted by mini-css-extract-plugin
export default {"users_table":"UsersTable_users_table__v6V7S"};